import {UI} from "../../../../../../stem-core/src/ui/UIBase";
import {keyframesRule, StyleSheet} from "../../../../../../stem-core/src/ui/Style";

import {Messages} from "../../../../../Messages";
import {styleRule, styleRuleInherit} from "../../../../../../stem-core/src/decorators/Style";
import {BlinkInput, BlinkInputStyle} from "../../../../../ui/Input";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {Spinner} from "../../../../../SVGElements";
import {NOOP_FUNCTION} from "../../../../../../stem-core/src/base/Utils";
import {isSmallScreen} from "../../../../../UtilsLib";


class InputElementStyle extends BlinkInputStyle {
    @styleRuleInherit
    input = {
        padding: "8px !important",
        margin: 0,
        borderRadius: this.themeProps.MERCHANT_BUTTON_INPUT_TOAST_BORDER_RADIUS,
        width: "100%",
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
    };

    @styleRuleInherit
    inputContainer = {
        height: 42,
        marginBottom: 0,
    };

    @styleRuleInherit
    element = {
        marginTop: 0,
        marginBottom: 0,
    };

    @styleRule
    successInput = {
        ">*>input": {
            color: this.themeProps.MERCHANT_SUCCESS,
        },
        ">:last-child": {
            border: () => "1px solid " + this.themeProps.MERCHANT_SUCCESS,
        }
    }
}

@registerStyle(InputElementStyle)
class InputElement extends BlinkInput {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            applySuccessStyle: false,
        }
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        if (this.options.applySuccessStyle) {
            attr.addClass(this.styleSheet.successInput);

        }
    }
}

export class SpinnerAnimation extends StyleSheet {
    @keyframesRule
    animation = {
        "0%": {
            transform: "rotate(0deg)",
        },
        "100%": {
            transform: "rotate(360deg)",
        },
    };
}

class DiscountCodeInputStyle extends StyleSheet {
    spinnerSize = 24;

    @styleRule
    discountCodeInput = {
        display: "flex",
        position: "relative",
        width: "100%",
        maxWidth: 418,
        textAlign: () => isSmallScreen() ? "left" : "center",
        marginLeft: () => isSmallScreen() ? "" : "auto",
        marginRight: () => isSmallScreen() ? "" : "auto",
    };

    @styleRule
    inputContainer = {
        display: "inline-block",
        flexDirection: "column",
        position: "relative",
        justifyContent: "center",
        flex: 1,
    };

    @styleRule
    inputFeedback = {
        position: "absolute",
        top: "100%",
        marginTop: 4,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_SMALL,
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    };

    @styleRule
    inputLabel = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        marginRight: 8,
        display: "inline-block",
        whiteSpace: "nowrap",
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
        alignSelf: "center",
    };

    @styleRule
    input = {
        borderRadius: 4,
        border: "1px solid transparent",
        width: `calc(100% - ${this.spinnerSize}px)`,
    };

    @styleRule
    loadingAnimation = {
        animation: `${SpinnerAnimation.getInstance().animation.toString()} .6s linear infinite`,
        marginLeft: 12,
        position: "absolute",
        right: 0,
        // TODO: find another way to vertically align loading animation element
        top: "32%",
    };

    @styleRule
    rightContainer = {
        display: "inline-block",
        marginLeft: 12,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_SMALL,
        color: this.themeProps.DISCOUNT_INPUT_MESSAGE_COLOR,
        verticalAlign: "middle",
    };
}

@registerStyle(DiscountCodeInputStyle)
export class DiscountCodeInput extends UI.Element {
    insertedValue = "";
    lastSentCode = null;
    LOADING_HANG_TIMEOUT = 500;
    REQUEST_THROTTLE = 300;

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            initialValue: "",
            discountApplied: null,
            failureMessage: null,
            onCodeInput: NOOP_FUNCTION,
            label: Messages.defaultDiscountCodeInputLabel,
        }
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.discountCodeInput);
    }

    render() {
        const {styleSheet} = this;
        const {discountApplied, initialValue, label} = this.options;

        return [
            label ? <div className={styleSheet.inputLabel}>{label}</div> : null,
            <div className={styleSheet.inputContainer}>
                <InputElement ref="input" className={styleSheet.input}
                              initialValue={initialValue && initialValue.length ? initialValue : this.insertedValue}
                              applySuccessStyle={!!discountApplied}
                              onChange={() => this.onInputChange()} />
                {this.loading ? <Spinner className={styleSheet.loadingAnimation}/> : null}
                {!(discountApplied || this.loading) && this.lastSentCode ? <div className={styleSheet.inputFeedback}>{Messages.invalidDiscountCode}</div> : null}
            </div>,
        ];
    }

    clear() {
        this.input.setValue("");
        this.lastSentCode = "";
        this.redraw();
    }

    sendCode() {
        this.lastSentCode = this.input.getValue();
        this.options.onCodeInput(this.lastSentCode);
    }

    onInputChange() {
        if (this.lastSentCode === this.input.getValue()) {
            return;
        }
        this.insertedValue = this.input.getValue()
        this.discountMessage = null;
        this.loading = true;
        this.redraw();
        if (this.sendCodeTimeout) {
            clearTimeout(this.sendCodeTimeout);
        }
        this.sendCodeTimeout = this.attachTimeout(() => {
            this.sendCode();
            this.attachTimeout(() => {
                if (!this.sendCodeTimeout) {
                    this.loading = false;
                    this.redraw();
                }
            }, this.LOADING_HANG_TIMEOUT);
            this.sendCodeTimeout = null;
        }, this.REQUEST_THROTTLE);
    }
}
